export default "__VITE_ASSET__DOgjTcEr__"